<template>
  <div class="content" v-bind:class="{ 'theme-red' : (roleId === 5 || roleId ===7) }">
    <div
      class="mobile-overlay"
      v-bind:class="[{'display-Block': displaySide, 'display-none': !displaySide}]"
      @click="displaySide=false;"
    ></div>
    <header-nav
      v-if="roleId"
      :roleId="roleId"
      :userCompany="userCompany"
      @mobilesidebar="mobilesidebar"
      :displaySide="displaySide"
      :account_id="account_id"
      :roleInfo="roleInfo"
    ></header-nav>
    <header-menu
      v-if="roleId"
      :roleId="roleId"
      @mobilesidebar="mobilesidebar"
      :accountId="account_id"
      :displaySide="displaySide"
      :showSEFlag="showSEFlag"
      :account_type_id="account_type_id"
      :roleInfo="roleInfo"
    ></header-menu>
    <router-view
      v-if="roleId"
      :roleId="roleId"
      :account_id="account_id"
      :userId="userId"
      :data="metaData"
      :account_type_id="account_type_id"
      :roleInfo="roleInfo"
    ></router-view>
    <progress-bar
      :showHelp="showHelp"
      :progressTitleStatus="progressTitleStatus"
      :progressStatus="progressStatus"
      :percentage="percentage"
      @updateProgressStatus="updateProgressStatus"
      :progressTitle="progressTitle"
    ></progress-bar>
    <timeout-warning></timeout-warning>
    <team-member-restriction></team-member-restriction>
  </div>
</template>
<script>
import $ from 'jquery';
import _ from 'lodash';
import HeaderNav from './HeaderNav.vue';
import HeaderMenu from './HeaderMenu.vue';
import welcomePopup from '../VirtualTour/WelcomePopup.vue';
import EventBus from '../../utils/event-bus';
import ProgressBar from '../UIComponents/ProgressBar.vue';
import TimeoutWarning from './TimeoutWarning.vue';
import TeamMemberRestriction from './TeamMemberRestriction.vue';
import { getUserData, getProfileData } from '../../apis/profile';
import { getAllCountries } from '../../apis/countriesList';
import { getRefreshToken } from '../../apis/login';
import { getRoles } from '../../apis/rbac';
// import { ROLE_INFO } from './constants';
// import { getTeamMemberRestriction } from '../../apis/team';

export default {
  data() {
    return {
      roleInfo: {},
      userCompany: '',
      roleId: '',
      userId: '',
      progressStatus: false,
      percentage: 0,
      errors: [],
      progressTitle: '',
      progressTitleStatus: '',
      showHelp: false,
      account_id: '',
      countryList: [],
      displaySide: false,
      refreshTokenInterval: '',
      rep_client_services: [1, 2, 4],
      timeoutID: null,
      account_type_id: null,
      showSEFlag: false,
      resizeEventHandler: '',
      tourStatus: false,
      metaData: [],
      options: [
        {
          name: '250 & 2GB',
          desc: 'Included',
          value: 250,
          storage: '2097152',
          price: '0',
        },
        {
          name: '1000 & 4GB',
          desc: '+$200',
          value: 1000,
          storage: '4194304',
          price: '200',
        },
        {
          name: '2000 & 6GB',
          desc: '+$300',
          value: 2000,
          storage: '6291456',
          price: '300',
        },
        {
          name: '3000 & 8GB',
          desc: '+$400',
          value: 3000,
          storage: '8388608',
          price: '400',
        },
        {
          name: '4000 & 10GB',
          desc: '+$500',
          value: 4000,
          storage: '10485760',
          price: '500',
        },
        {
          name: '5000 & 12GB',
          desc: '+$600',
          value: 5000,
          storage: '12582912',
          price: '600',
        },
      ],
    };
  },
  components: {
    TimeoutWarning,
    HeaderNav,
    HeaderMenu,
    ProgressBar,
    TeamMemberRestriction,
    welcomePopup,
  },
  methods: {
    async getRoleInfo() {
      const roles = await getRoles();
      this.roleInfo = roles.reduce((result, item) =>
        ({ ...result, [item.role_name]: item.role_id }),
      {});
    },

    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    mobilesidebar() {
      this.displaySide = !this.displaySide;
    },
    updateProgressStatus() {
      this.progressStatus = false;
    },
    async getUserData() {
      const userDataStorage = await getUserData();
      if (userDataStorage) {
        this.roleId = userDataStorage.role_id;
        this.userId = userDataStorage.id;
        this.account_id = userDataStorage.account_id;
        this.account_type_id = userDataStorage.account_type_id;
        this.userCompany = userDataStorage.company;
        localStorage.setItem('userId', userDataStorage.id);
        localStorage.setItem('userData', JSON.stringify(userDataStorage));
        if (this.roleId === 4 && (!this.$route.path.includes('/report') && !this.$route.path.includes('/market-place/service/1') && !this.$route.path.includes('/layout/PermissionAccess'))) {
          window.location.href = '/layout/report/summary';
        }
      }
      EventBus.$on('updateUserCompanyName', (data) => {
        this.userCompany = data;
      });
    },
    async getProfileData() {
      const userDataStorage = await getProfileData();
      if (userDataStorage) {
        localStorage.setItem('profileData', JSON.stringify(userDataStorage));
      }
    },
    addSocketEvents(userId) {
      socket.on(`alertSaveMultiRegistrationDetails_${userId}`, (data) => {
        if (!this.progressStatus) {
          this.progressStatus = true;
          this.progressTitle = 'registrations';
          this.progressTitleStatus = 'import';
          this.showHelp = false;
        }
        this.percentage = data;
      });
    },
    removeSocketEvents(userId) {
      socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${userId}`);
    },
    idleTimer() {
      window.addEventListener('mousemove', this.resetTimer, false); // catches mouse movements
      window.addEventListener('mousedown', this.resetTimer, false); // catches mouse movements
      window.addEventListener('keypress', this.resetTimer, false); // catches mouse clicks
      window.addEventListener('click', this.resetTimer, false); // catches scrolling
      window.addEventListener('scroll', this.resetTimer, false); // catches keyboard actions
      window.addEventListener('keydown', this.resetTimer, false);
    },
    resetTimer() {
      clearTimeout(this.timeoutID);
      localStorage.setItem('updateIdle', Date.now());
      this.timeoutID = setTimeout(() => {
        $('#warningTimeout').modal({ backdrop: 'static', keyboard: false });
      }, 900000);
    },
    // async checkTeamMemberRestriction() {
    //   if (this.account_type_id !== 1 || this.account_type_id !== 5) {
    //     const response = await getTeamMemberRestriction({ is_rep: (this.account_type_id === 2 || this.account_type_id === 4) });
    //     if (response.status_code === 200 && response.restrict_user) {
    //       $('#teamMemberRestrictionPopup').modal({ backdrop: 'static', keyboard: false });
    //     }
    //   }
    // },
  },
  watch: {
    userId() {
      this.removeSocketEvents(this.userId);
      setTimeout(() => {
        this.addSocketEvents(this.userId);
      }, 0);
    },
    $route() {
      if (this.$route.path !== '/layout/market-place/renew-service') sessionStorage.removeItem('renewalServices');
      if (this.roleId === 4 && (!this.$route.path.includes('/report') && !this.$route.path.includes('/market-place/service/1') && !this.$route.path.includes('/layout/PermissionAccess'))) {
        window.location.href = '/layout/report/summary';
      }
    },
  },
  async created() {
    this.resizeEventHandler = _.debounce(() => {
      if (!this.tourStatus) {
        this.displaySide = false;
      }
    }, 500);
    await this.getRoleInfo();
    // const token = getCookie('Authorization').split('Bearer ')[1];
    await this.getProfileData();
    await this.getUserData();
    await getRefreshToken();
    // await this.checkTeamMemberRestriction();
    await this.getRoleInfo();
    this.countryList = await getAllCountries();
    this.idleTimer();
    EventBus.$on('resetTimer', () => {
      this.resetTimer();
    });
    EventBus.$on('CloseMobileSideNav', () => {
      if (this.displaySide) this.displaySide = false;
    });
    EventBus.$on('alertSaveMultiRegistrationDetails', (data) => {
      if (!this.progressStatus) {
        this.progressStatus = data.progressStatus;
        this.progressTitle = 'registrations';
        this.progressTitleStatus = 'import';
        this.showHelp = false;
      }
      this.percentage = data.percentage;
      if (data.percentage === 100) {
        EventBus.$emit('bulkUpload', { disableAdd: false });
      } else {
        EventBus.$emit('bulkUpload', { disableAdd: true });
      }
    });
    this.refreshTokenInterval = setInterval(getRefreshToken, 1680000);
    EventBus.$on('tourStart', () => {
      this.tourStatus = true;
      $(window).scrollTop(0);
      $('.sidebar-col').scrollTop(0);
      // $('body').addClass('hide_scroll');
      this.mobilesidebar();
    });
    EventBus.$on('tourEnd', () => {
      this.tourStatus = false;
      // $('body').removeClass('hide_scroll');
    });
    EventBus.$on('closeMobileSideBar', () => {
      this.displaySide = !this.displaySide;
    });
  },
  mounted() {
    window.addEventListener('resize', this.resizeEventHandler);
    $(window).on('beforeunload', () => {
      localStorage.setItem('removeIdlePopups', true);
    });
  },
  beforeDestroy() {
    clearInterval(this.refreshTokenInterval);
    window.removeEventListener('mousemove', this.resetTimer); // catches mouse movements
    window.removeEventListener('mousedown', this.resetTimer); // catches mouse movements
    window.removeEventListener('keypress', this.resetTimer); // catches mouse clicks
    window.removeEventListener('click', this.resetTimer); // catches scrolling
    window.removeEventListener('scroll', this.resetTimer);
    window.removeEventListener('keydown', this.resetTimer);
    window.removeEventListener('resize', this.resizeEventHandler);
    clearTimeout(this.timeoutID);
    EventBus.$off();
  },
};
</script>
<style scoped>
@media only screen and (min-width: 1301px) {
  .mobile-overlay {
    display: none !important;
  }
}
.display-Block {
  display: block;
}
.display-none {
  display: none;
}
.mobile-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
  cursor: pointer;
}
</style>
